import React from 'react';

interface Props { children: React.ReactNode; fallback?: React.ReactNode }
interface State { hasError: boolean; error: Error | null }

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('[ErrorBoundary]', error, info);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] p-8 text-center gap-4">
          <span className="material-icons text-5xl text-error-text">warning</span>
          <h2 className="text-error-text m-0 text-2xl">
            Something went wrong
          </h2>
          <pre className="text-sm text-on-surface-variant bg-surface-container py-3 px-4 rounded-sm max-w-[600px] overflow-auto text-left">
            {this.state.error?.message}
          </pre>
          <div className="flex gap-3">
            <button
              onClick={() => window.location.reload()}
              className="btn-primary"
            >
              Reload page
            </button>
            <a
              href="/"
              className="py-2.5 px-5 bg-surface-container-high text-on-surface border-none rounded-sm font-semibold text-md no-underline inline-flex items-center"
            >
              Go home
            </a>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
